// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import React from "react";
import { createRoot } from "react-dom/client"; // ✅ use createRoot
import { Hello } from "../components/hello";
import "chartjs-adapter-date-fns";
import Chartkick from "chartkick";
import Chart from "chart.js/auto";
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
Chartkick.use(Chart);


document.addEventListener('turbolinks:load', () => {
  const calendarEl = document.getElementById('absences-calendar');
  if (!calendarEl) return;

  const calendar = new Calendar(calendarEl, {
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    initialView: 'dayGridMonth',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    events: '/admin/absences_calendar.json',
    locale: ptBrLocale, // <- aqui!
    eventColor: 'blue',
    eventDidMount: function(info) {
      if(info.event.extendedProps.note){
        info.el.setAttribute('title', info.event.extendedProps.note);
      }
    }
  });

  calendar.render();
});

document.addEventListener("turbolinks:load", () => {
  const rootElement = document.getElementById("react-root");
  if (rootElement) {
    console.log("Mounting React component with createRoot");
    const root = createRoot(rootElement); // ✅ use createRoot here
    root.render(<Hello />);
  }
});


Rails.start()
Turbolinks.start()
ActiveStorage.start()


document.addEventListener("turbolinks:load", function () {
  const sidebar = document.getElementById('sidebar');
  const toggleBtn = document.getElementById('toggleBtn');
  const mainContent = document.getElementById('mainContent');
  const logoutBtn = document.getElementById('logoutBtn');

  if (!sidebar || !mainContent) return;

  // Read state from localStorage
  if (localStorage.getItem('sidebar-collapsed') === 'true') {
    sidebar.classList.add('collapsed');
  } else {
    sidebar.classList.remove('collapsed');
  }

  function adjustMainContentMargin() {
    if (sidebar.classList.contains('collapsed')) {
      mainContent.style.marginLeft = '0rem';
      mainContent.style.width = '100%';
      if (logoutBtn) logoutBtn.classList.remove("ms-2");
    } else {
      mainContent.style.marginLeft = '0rem';
      mainContent.style.width = '100%';
      if (logoutBtn) logoutBtn.classList.add("ms-2");
    }
  }

  if (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      sidebar.classList.toggle('collapsed');

      // Save state to localStorage
      localStorage.setItem('sidebar-collapsed', sidebar.classList.contains('collapsed'));

      adjustMainContentMargin();
    });
  }

  adjustMainContentMargin();
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest("[data-toggle='audit-row']");
  if (btn) {
    const target = document.querySelector(btn.dataset.target);
    if (target) target.classList.toggle("d-none");
  }

  const rawBtn = e.target.closest("[data-toggle='raw']");
  if (rawBtn) {
    const target = document.querySelector(rawBtn.dataset.target);
    if (target) target.classList.toggle("d-none");
  }

  const copyBtn = e.target.closest("[data-copy]");
  if (copyBtn) {
    const pre = document.querySelector(copyBtn.dataset.copy);
    if (pre) {
      navigator.clipboard.writeText(pre.innerText)
        .then(() => {
          copyBtn.textContent = "Copiado!";
          setTimeout(() => (copyBtn.textContent = "Copiar JSON"), 1200);
        })
        .catch(() => alert("Não foi possível copiar"));
    }
  }
});

document.addEventListener('turbolinks:load', () => {
  // const btn = e.target.closest("[data-toggle='audit-row']");
  const auditBtn = document.getElementById('audit-log-btn');

  if (auditBtn) {
    auditBtn.addEventListener("click", function(e) {
      if (!auditBtn) return;
      const target = document.querySelector(auditBtn.getAttribute("data-target"));
      if (!target) return;
      target.classList.toggle("d-none");
    });
  }
});

document.addEventListener("turbolinks:load", () => {
  document.querySelectorAll(".tom-select").forEach((el) => {
    if (el.tomselect) return;

    new TomSelect(el, {
      create: false,
      placeholder: "Digite o número SEI...",
      allowEmptyOption: true
    });
  });
});